var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('hr'),_c('small',[_c('fa-icon',{attrs:{"icon":"copyright"}}),_vm._v(" 2025 Pain Medics. All rights reserved. ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }